import Expando from './Expando';

export default Expando;
